import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { NebulaFormsModule } from '../nebula-forms/nebula-forms.module';
import { NebulaIconsModule } from '../nebula-icons/nebula-icons.module';
import { EntityShortNamePipe } from '../nebula-table/entity-shortname-pipe/entity-shortname.pipe';
import { NebulaTableModule } from '../nebula-table/nebula-table.module';
import { EmphasizePipe } from './emphasize/emphasize.pipe';
import { NebulaAutocompleteComponent } from './nebula-autocomplete.component';

@NgModule({
  imports: [
    CommonModule,
    NebulaFormsModule,
    NebulaIconsModule,
    MatChipsModule,
    MatListModule,
    MatAutocompleteModule,
    NebulaTableModule,
    TranslateModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    NebulaAutocompleteComponent,
    EmphasizePipe
  ],
  exports: [
    NebulaAutocompleteComponent
  ],
  providers: [EntityShortNamePipe]
})
export class NebulaAutocompleteModule { }
